

import React, { useEffect, useState } from "react";
import {
  InteractiveMap,
  Layer,
  Marker,
  NavigationControl,
  Source,
  Popup,
} from "react-map-gl";

const TrackingPlayBackMap = ({actualLocationsAI, setRoutePoints, routePosition}) => {

  const [viewport, setViewport] = useState({
      latitude: -1.286389,
      longitude: 36.817223,
      zoom: 10,
      width: "100%",
      height: "100%",
    });




const [routeGeoJSON, setRouteGeoJSON] = useState(null);

    
  // Convert points to GeoJSON


  const layerStyle = {
    id: "route",
    type: "line",
    paint: {
      "line-color": "#ff0000",
      "line-width": 4,
    },
  };

  const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
 
 
  const getActualDrivingRoute = async (startLat, startLng, endLat, endLng) => {
    const accessToken =
      "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${startLng},${startLat};${endLng},${endLat}?geometries=geojson&access_token=${accessToken}`;

    const res = await fetch(url);
    const data = await res.json();

    const coordinates = data.routes?.[0]?.geometry?.coordinates;
    setRoutePoints(coordinates);

    if (coordinates && coordinates.length > 0) {
      return {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates,
        },
      };
    }

    return null;
  };

  useEffect(() => {
      const fetchRoute = async () => {
        if (!actualLocationsAI?.length) return;
  
        const { StartLat, StartLng, EndLat, EndLng } = actualLocationsAI[0];
        const startLat = parseFloat(StartLat);
        const startLng = parseFloat(StartLng);
        const endLat = parseFloat(EndLat);
        const endLng = parseFloat(EndLng);
  
        if (isNaN(startLat) || isNaN(startLng) || isNaN(endLat) || isNaN(endLng))
          return;
  
        const route = await getActualDrivingRoute(
          startLat,
          startLng,
          endLat,
          endLng
        );
        if (route) {
          setRouteGeoJSON(route);
          setViewport((prev) => ({
            ...prev,
            latitude: (startLat + endLat) / 2,
            longitude: (startLng + endLng) / 2,
            zoom: 12,
          }));
        }
      };
  
      fetchRoute();
    }, []);
    
  return (
    <>
    <InteractiveMap
    {...viewport}
              onViewportChange={(newViewport) => setViewport(newViewport)}
              width={"100%"}
              height={"100vh"}
              mapStyle={
                   "mapbox://styles/mapbox/streets-v11"
              }
              mapboxApiAccessToken={MAPBOX_TOKEN}
              scrollZoom={true} // Enables scrolling
              dragPan={true} // Allows dragging
              doubleClickZoom={true}
              touchZoom={true}
              attributionControl={true}
            >
              {routePosition?.length > 0 &&(

                           <Marker latitude={routePosition?.[1]} longitude={routePosition?.[0]} anchor="center">
                             <div
                               style={{
                                 width: 16,
                                 height: 16,
                                 background: "#06CE06",
                                 borderRadius: "50%",
                                 border: "2px solid #fff",
                                 boxShadow: "0 0 4px #06CE06",
                               }}
                               title={"siva"}
                             />
                           </Marker>
              )}
      
      <Source id="green-route" type="geojson" data={routeGeoJSON}>
                  <Layer
                    id="green-line-layer"
                    type="line"
                    paint={{
                      "line-color": "green",
                      "line-width": 4,
                    }}
                  />
                </Source>
    </InteractiveMap>

    </>
  );
};

export default TrackingPlayBackMap;
